module.exports = __webpack_public_path__ + "static/sample write2smile 100-5542aaa57eebb361ff761a0163d61d8c.png";